import { ElementRulesEditorViewProps } from "@graffer-inc/form-builder";
import {
  IFieldElementUnion,
  IRepeatableElement,
} from "@graffer-inc/form-schema";
import { DefaultEditorRegistry } from "../../../../../../common/form-builder-wrapper";
import { useMemo } from "react";
import { TotalFileSizeIndicator } from "./total-file-size-indicator";

export const SmartApplyFileEditorFactory = (
  totalFileSize: number,
  elem: IFieldElementUnion,
  parent?: IRepeatableElement,
): React.FC<ElementRulesEditorViewProps> | undefined => {
  return useMemo(() => {
    const component: React.FC<ElementRulesEditorViewProps> = (props) => {
      const Editor = DefaultEditorRegistry.getElementEditor(elem, parent);
      if (!Editor) {
        return undefined;
      }
      return (
        <>
          <div className="ml-3">
            <TotalFileSizeIndicator totalFileSize={totalFileSize} />
          </div>
          <Editor {...props} />
        </>
      );
    };
    return component;
  }, [elem, parent, totalFileSize]);
};
